import { ILayoutState } from './types';
import LayoutsService from 'external-services/layouts-service/layouts.service';
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ILayout } from 'shared-types/SharedTypes';

const NS = 'layoutSlice';

const initialState: ILayoutState = {
  couchReducedLayouts: null,
  headerHeight: 0,
  timeBarHeight: 0,
};

export const loadLayout = createAsyncThunk(
  'layout/loadLayout',
  async (payload: void, { rejectWithValue, dispatch, getState }) => {
    let layouts: ILayout[] = [];

    try {
      layouts = await LayoutsService.getAllLayouts();
    } catch (e: any) {
      console.log(NS, 'loadLayout', e);
      return rejectWithValue(e.message);
    }

    return layouts;
  }
);


const layoutSlice = createSlice({
  name: 'layout', // used in action types
  initialState,
  reducers: {
    setHeaderHeight: (state: ILayoutState, action: PayloadAction<number>) => {
      state.headerHeight = action.payload;
    },
    setTimeBarHeight: (state: ILayoutState, action: PayloadAction<number>) => {
      state.timeBarHeight = action.payload;
    },
    reset: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(loadLayout.fulfilled, (state: ILayoutState, action) => {
      state.couchReducedLayouts = action.payload;
    });
  },
});

// Extract the action creators object and the reducer
const { actions, reducer } = layoutSlice;
// Extract and export each action creator by name
export { actions as layoutActions };
// Export the reducer, either as a default or named export
export default reducer;
